(function () {

    'use strict';

    angular.module('Services').factory('CarrierZonePostcodeFileTableService', CarrierZonePostcodeFileTableService);

    CarrierZonePostcodeFileTableService.$inject = ['Carrier', 'TableLiteFactory', 'CommonService', '$location'];

    function CarrierZonePostcodeFileTableService(Carrier, TableLiteFactory, CommonService, $location) {
        return function (carrierProfileId) {
            var tableData = {};
            var activeFilters = {};
            var paginationFilter = {};
            var sortingFilter = {
                page: 0
            };
            const bookingStatuses = {
                inprogress: 'In Progress',
                processed: 'Completed',
                pending: 'Pending'
            };
            var tableStructure = {
                tableName: 'CarrierZonePostcodeFileTable',
                /*optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Create New Zone Postcode Profile',
                        onClick: function () {
                            $location.path('/carriers/zone-postcodes/new');
                        }
                    }]
                },*/
                headers: [{
                    label: 'PROFILE NAME',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search'
                    },
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        refresh: function (model) {
                            let selected = this.model;
                            let filterItems = this.items;
                            Carrier.getExternalCarrierProfiles((data)=>{
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile)=>{
                                    if(profile.id === carrierProfileId){
                                        selected.name = profile.name;
                                        //tableStructure.optionAddOns.select.model = profile;
                                        carrierProfileId = null;
                                    }
                                    filterItems.push(profile);
                                });
                            }, (error)=>{
                                console.log(error);
                            },{size:1000,name:model ? model : ''})
                        },
                        model: carrierProfileId ? {name:' '} : null
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'DATE CREATED',
                    viewName: 'date_created',
                    filterName: 'date_created'
                }, {
                    label: 'LAST MODIFIED',
                    viewName: 'last_modified',
                    filterName: 'last_modified'
                }, {
                /*    label: 'ACTION - ZONE POSTCODES',
                    viewName: 'zone_code_action',
                    filterName: 'zone_code_action',
                    align: 'center',
                }, {*/
                    label: 'NO. SERVICE<br>PROFILES ASSIGNED',
                    viewName: 'service_no',
                    filterName: 'service_no'
                /*}, {
                    label: 'VIEW / EDIT<br>SERVICE PROFILE',
                    viewName: 'profile_action',
                    filterName: 'profile_action',
                    align: 'center',
                }, {
                    label: 'CREATE SERVICE PROFILE +',
                    viewName: 'create_profile_action',
                    filterName: 'create_profile_action',
                    align: 'center',*/
                }],
                data: [],
                applyFilters: function (item) {
                    angular.extend(paginationFilter, {
                        size: item,
                        page: 0
                    });
                    sendRequest();
                },
                extractTable: function (form) {

                },
                onPageChanged: function () {
                    angular.extend(paginationFilter, {
                        page: this.currentPage - 1
                    });
                    sendRequest();
                },
                rowOnClick: function (item) {
                },
                resetFilters: function () {

                },
                onInit: function () {
                    sendRequest({
                        size: 10,
                        page: 0,
                        sort: 'id',
                        carrierProfileId: carrierProfileId
                    });
                },
                totalItems: 2,
                numberOfItems: 10,
                totalPages: 1,
                itemView: 20,
                itemViewRaw: 20,
                currentPage: 1
            };

            function sort(filterName) {
                if (tableData.sort && tableData.sort[0].property !== filterName) {
                    sortingFilter.sort = filterName;
                } else if (!tableData.sort || tableData.sort[0].property == filterName &&
                    !tableData.sort[0].direction.toLowerCase() == 'desc') {
                    sortingFilter.sort = filterName;
                } else if (tableData.sort[0].direction.toLowerCase() == 'asc') {
                    sortingFilter.sort = filterName + ',desc';
                } else if (tableData.sort[0].direction.toLowerCase() == 'desc') {
                    delete sortingFilter.sort;
                    delete paginationFilter.sort;
                    delete activeFilters.sort;
                }

                sendRequest(sortingFilter);
            }

            function evaluateFilter(header) {
                var filter = {};
                if (header.filter.model)
                    filter[header.filterName] = header.filter.model;
                else if (activeFilters[header.filterName])
                    delete activeFilters[header.filterName];

                return filter;
            }

            function sendRequest(filter) {
                angular.extend(activeFilters, paginationFilter, filter);
                var ids = [];
                Carrier.getZonePostcodeFiles(function (data) {
                    tableData = buildTableData(data, activeFilters);
                }, function (err) {
                    tableData = buildTableData(null, activeFilters);
                }, activeFilters);
            };

            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                if (pagination)
                    paginationFilter = pagination;

                tableData = tableStructure;
                tableData.data = [];

                angular.extend(tableData, TableLiteFactory.getCommonProperties(data));
                if (!data)
                    return tableData;

                angular.forEach(data.content, function (item, index) {
                    item.href = '/carriers/carrier-zones/' + item.id;
                    /*item.zone_code_action = {
                        type: 'button',
                        buttons: [{
                            text: 'View / Edit +',
                            class: 'btn-primary btn-quirk btn-wide',
                            action: function (row) {
                                $location.path('/carriers/postcode-profiles/view/' + row.id);
                            }
                        }]
                    };

                    item.profile_action = {
                        type: 'button',
                        buttons: [{
                            text: 'View / Edit +',
                            class: 'btn-primary btn-quirk btn-wide',
                            action: function (row) {
                                console.log('Im id:' + row.id + ', where will I go?');
                            }
                        }]
                    };

                    item.create_profile_action = {
                        type: 'button',
                        buttons: [{
                            text: 'Create Service Profile +',
                            class: 'btn-primary btn-quirk btn-wide',
                            action: function (row) {
                                console.log('Im id:' + row.id + ', where will I go?');
                            }
                        }]
                    };*/
                    item.carrierProfileName = item.carrierProfile.name;
                    tableData.data.push(item);
                });
                /*** END - Building of Data ***/

                return tableData;
            };
            this.tableData = tableStructure;
        };
    };
})();


// WEBPACK FOOTER //
// ./js/services/tables/CarrierZonePostcodeFileTableService.js